import { render, staticRenderFns } from "./Me.vue?vue&type=template&id=13e4215c&scoped=true"
import script from "./Me.vue?vue&type=script&lang=js"
export * from "./Me.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e4215c",
  null
  
)

export default component.exports